var initializeEllipsis = function(currentElement) { 
  currentElement.querySelectorAll('.ellipsis').forEach(function (e) {
    if (e.offsetWidth < e.scrollWidth) {
      e.setAttribute('title', (e.children[0])? e.children[0].textContent : '');
      e.classList.add("title");
    } else{
      e.removeAttribute('title');
      e.classList.remove("title");
    }
  });
}

export default initializeEllipsis;